import { ActionType, createReducer } from 'typesafe-actions';
import { combineReducers } from 'redux';
import { TrustDocumentsResponse } from '../types';
import { FETCH_TRUST_DOCUMENTS, RESET_TRUST_DOCUMENTS } from './actions';

type TrustDocumentsReducerActions =
  | ActionType<typeof FETCH_TRUST_DOCUMENTS.request>
  | ActionType<typeof FETCH_TRUST_DOCUMENTS.success>
  | ActionType<typeof FETCH_TRUST_DOCUMENTS.failure>
  | ActionType<typeof FETCH_TRUST_DOCUMENTS.cancel>
  | ActionType<typeof RESET_TRUST_DOCUMENTS>;

const data = createReducer<TrustDocumentsResponse | null, TrustDocumentsReducerActions>(null)
  .handleAction(
    [FETCH_TRUST_DOCUMENTS.failure, FETCH_TRUST_DOCUMENTS.cancel, RESET_TRUST_DOCUMENTS],
    () => null,
  )
  .handleAction(FETCH_TRUST_DOCUMENTS.success, (_, { payload }) => payload);

const loading = createReducer<boolean, TrustDocumentsReducerActions>(false)
  .handleAction([FETCH_TRUST_DOCUMENTS.request], () => true)
  .handleAction(
    [
      FETCH_TRUST_DOCUMENTS.success,
      FETCH_TRUST_DOCUMENTS.failure,
      FETCH_TRUST_DOCUMENTS.cancel,
      RESET_TRUST_DOCUMENTS,
    ],
    () => false,
  );

const error = createReducer<Error | string | null, TrustDocumentsReducerActions>(null)
  .handleAction([FETCH_TRUST_DOCUMENTS.failure], (_, { payload }) => payload)
  .handleAction(
    [
      FETCH_TRUST_DOCUMENTS.request,
      FETCH_TRUST_DOCUMENTS.success,
      FETCH_TRUST_DOCUMENTS.cancel,
      RESET_TRUST_DOCUMENTS,
    ],
    () => null,
  );

export const trustDocumentsReducer = combineReducers({
  data,
  loading,
  error,
});
